
export const DEFAULT_TABLE_ROWS = 10;
export const DEFAULT_TABLE_PAGE = 1;
export const DEFAULT_APP_LANGUAGE = "fr";


export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_TOGGLE_MENU = "SET_TOGGLE_MENU";

export const ROLE_ADMIN = "ADMIN";
export const ROLE_ARMATEUR = "ARMATEUR";
export const ROLE_USINIER = "USINIER";
export const ROLE_EXPORTATEUR = "EXPORTATEUR";
export const ROLE_MAREYEUR = "MARAYEUR";

export const CODE_ACQU_MARAYEUR = "1";
export const CODE_ACQU_ARMATEUR = "2";
export const CODE_ACQU_USINIER = "3";
export const CODE_ACQU_EXPORTATEUR = "4";

export const CC_ETAT_ENCOURS_VALIDATION = "0";
export const CC_ETAT_VALIDER = "1";
export const CC_ETAT_CONFIRMER = "3";
export const CC_ETAT_EN_ATTETE_CONFIRMATION_ANNULATION = "7";

export const CP_TYPETRANS_CONSERVE = "Conserve";
export const CP_TYPETRANS_CONGELE = "Congele";
